<template>
  <v-sheet class="promotion" style="height: calc(100vh - 140px)">
    <v-card-text class="px-0 custom_field_height">
      <v-row>
        <v-col md="3" class="py-0 pr-0" style="max-width: 340px" v-if="false">
          <label for="segment_name" class="custom-form-label" style="font-weight: 600">Filter By Date Range</label>
          <DateRangePicker hide-details class="mt-3" v-model="range" :disabled="pageLoading" :loading="pageLoading"
            id="item-sale-duration" placeholder="Date Range"></DateRangePicker>
        </v-col>
        <v-col class="py-0 pr-0" style="max-width: 180px; width: 180px">
          <label for="segment_name" class="custom-form-label" style="font-weight: 600">Filter by Paid Month</label>
          <AutoCompleteInput class="mt-3" hide-details :disabled="pageLoading" :loading="pageLoading" :items="months"
            id="segment" item-text="name" item-value="value" v-model="search_month" placeholder="Select Month">
          </AutoCompleteInput>
        </v-col>
        <v-col class="py-0 pr-0" style="max-width: 180px; width: 180px">
          <label for="segment_name" class="custom-form-label" style="font-weight: 600"
            >Filter by Paid Year</label
          >
          <AutoCompleteInput
            class="mt-3"
            hide-details
            :disabled="pageLoading"
            :loading="pageLoading"
            :items="yearlist"
            id="segment" 
            v-model="search_year"
             placeholder="Select Year" 
          >
          </AutoCompleteInput>
        </v-col>
        <!-- <v-col md="1" class="py-0 pr-0">
            <label for="category_type" class="custom-form-label" style="font-weight: 600"
              >Filter by Category</label
            >
            <AutoCompleteInput
              hide-details
              class="mt-3"
              :disabled="pageLoading"
              :loading="pageLoading"
              :items="['Members', 'Premium']"
              id="category"
              item-text="name"
              item-value="id"
              placeholder="Select Type"
            ></AutoCompleteInput>
          </v-col> -->
        <v-col md="3" class="mt-5 px-0">
          <v-flex>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn style="max-width: 10px" color="blue darken-4" v-on="on" v-bind="attrs" depressed tile
                  @click="searchPromotions" class="ml-2 white--text me-1 px-1">
                  <v-icon>mdi-magnify</v-icon></v-btn>
              </template>
              <span>Filter</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="red darken-4" v-on="on" v-bind="attrs" depressed tile v-on:click="reset"
                  class="ml-2 white--text me-1">Reset
                </v-btn>
              </template>
              <span>Reset </span>
            </v-tooltip>
            <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue darken-4"
                    v-on="on"
                    v-bind="attrs"
                    depressed
                    tile
                    class="ml-2 white--text"
                    ><v-icon>mdi-file-excel</v-icon></v-btn
                  >
                </template>
                <span>Export</span>
              </v-tooltip> -->
          </v-flex>
        </v-col>
        <v-col class="mt-5 justify-content-end ps-0">
          <v-flex class="d-flex justify-content-end">
            <v-btn :disabled="pageLoading" color="blue darken-4" depressed tile class="ml-2 white--text"
              v-on:click="addPayment()">
              New
            </v-btn>
            <v-menu offset-y transition="slide-y-transition" :close-on-content-click="false" v-if="false">
              <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn color="blue darken-4" depressed tile v-bind="attrs" v-on="{ ...tooltip, ...menu }"
                      class="white--text">
                      <v-icon>edit_note</v-icon>
                    </v-btn>
                  </template>
                  <span>Columns arrangement and visibility</span>
                </v-tooltip>
              </template>
              <v-list nav dense>
                <v-list-item draggable @dragstart="dragstart(index)" @dragover="dragover(index)" @dragend="dragEnd"
                  v-for="(item, index) in defaultColDefs" :key="item.field + '_' + index"
                  class="flex-column column-arrangement-list-item cursor-move">
                  <div class="d-flex flex-row">
                    <v-checkbox :ripple="false" hide-details color="#0d47a1" v-model="defaultColShow"
                      v-bind:value="item.field" :disabled="Number(item.fixed) || pageLoading"
                      v-on:change="updateVisible()" class="m-0"></v-checkbox>
                    <v-list-item-title>{{ item.headerName }}</v-list-item-title>
                    <v-icon>drag_indicator</v-icon>
                  </div>
                  <v-divider v-if="index < customThead.length - 1" class="mt-1 mb-0" style="width: 100%"></v-divider>
                </v-list-item>
              </v-list>
            </v-menu>

          </v-flex>
        </v-col>
      </v-row>
    </v-card-text>
    <SearchCriteria v-if="listingSearch" :search="listingSearch"
      search-string="Promotion #, Full Name, Email, Phone No. and Address" v-on:close-search="resetSearch">
    </SearchCriteria>
    <v-simple-table fixed-header class="bt-table table_height">
      <template v-slot:default>
        <thead>
          <tr>
            <th v-for="heading in customThead" :key="heading.title" style="background-color: #f5f5f5">
              <div v-if="heading.status">{{ heading.headerName }}</div>
            </th>
          </tr>
        </thead>
        <Draggable tag="tbody" v-model="promotions" class="draggable-group" handle=".draggable-drag-icon"
          v-on:change="updateItemOrder($event)">
          <template v-if="promotions.length">
            <tr v-for="(row, bkey) in promotions" :key="bkey" :class="bkey % 2 === 0 && 'blue lighten-5'"    v-on:click="routeToDetail(row)"
              class="promotion-listing-tr">
              <td v-for="(th, index) in customThead" :key="'key_' + index" :width="th.field == 'ACTION' ? '50px' : ''">
                <div v-if="th.field === 'title' && th.status">
                  <template>
                    {{ row.title }}
                  </template>

                </div>
                <div v-else-if="th.field === 'action' && th.status">
                  <v-tooltip top content-class="custom-top-tooltip" v-if="selectstatus == 'Active' && sequence == 1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="draggable-drag-icon cursor-move" color="blue darken-4">mdi-drag</v-icon>
                    </template>
                    <span>Payment</span>
                  </v-tooltip>
                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed fab dark x-small class="mx-2" color="green" v-bind="attrs" v-on="on"
                        v-on:click.stop.prevent="routeToDetail(row)">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View</span>
                  </v-tooltip>
                  
                </div>
                <div v-else-if="th.field === 'barcode' && th.status">
                  <v-chip outlined label color="indigo" v-if="row.barcode">
                    {{ row.barcode }}
                  </v-chip>  
                  <span v-if="!row.barcode" class="text-muted" style="width: 250px">
                    No barcode
                  </span>
                </div>
                <div v-else-if="th.field === 'type' && th.status">
                  <v-chip outlined label color='green'>
                    {{ row.type_text }}
                  </v-chip>
                </div>
                  <div v-else-if="th.field === 'utility_name' && th.status">
                   <span v-if="row.title">  {{ row.title }}</span>
                     <span v-if="!row.title" class="text-muted" style="width: 250px">
                    No name
                  </span>
                 
                </div>

                <div v-else-if="th.field === 'remark' && th.status">
                  <div v-if="row.remark" class="text-truncate" style="width: 250px">
                    {{ stripHtmlTags(row.remark) }}
                  </div>
                  <span v-if="row && row.remark && row.remark.length > 20"
                    style="color: #24326d; cursor: pointer; font-size: 12px" v-on:click.stop.prevent="
                      remarkPop(row.remark)
                    ">Read More</span>
                  <div v-if="!row.remark" class="text-muted" style="width: 250px">
                    No Remark
                  </div>
                </div>

                <div v-else-if="th.field === 'amount' && th.status">

                  <div v-if="row.amount" style="width: 250px">
                    {{ formatMoney(row.amount) }}
                  </div>
                  <div v-else class="text-muted" style="width: 250px">
                    No Amount Provided
                  </div>
                </div>
                <div v-else-if="th.field === 'month_name' && th.status">
                  <div class="text-sm mt-1">
                    <div>
                      <template v-if="row.full_date"> <v-chip label color="green">
                          <span class="text-uppercase text-light">
                            {{ row.full_date }}</span>
                        </v-chip>
                      </template>
                      <div v-else class="text-muted" style="width: 250px">
                        No Month Mentioned
                      </div>
                    </div>
                  </div>

                </div>

                <div v-else-if="th.field === 'created_at' && th.status">
                  <div class="text-sm mt-1">
                    <div>
                      <v-icon start size="16">mdi-calendar</v-icon>
                      {{ formatedate(row.added_at) }}
                      <VTooltip activator="parent"> Created date </VTooltip>
                    </div>
                  </div>
                  <div class="text-sm mt-1">
                    <div>
                      <v-icon start size="16">mdi-clock</v-icon>
                      {{ formateTime(row.added_at) }}
                      <VTooltip activator="parent"> Created Time </VTooltip>
                    </div>
                  </div>
                </div>

              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="9">
                <p class="m-0 text-center">
                  <img width="30" :src="$assetURL('media/error/empty.png')" class="row-not-found-image mr-4" />
                  Uhh... There are no utility payment at the moment.
                </p>
              </td>
            </tr>
          </template>
        </Draggable>
      </template>
    </v-simple-table>

    <Dialog :dialog="dialog" :dialogWidth="900">
      <template v-slot:title>Description</template>
      <template v-slot:body>
        <v-row class="delete-dialog"> 
          <v-col md="10" class="m-3 py-0 my-auto">
            <p class="btx-p m-0"><b class="red--text text--lighten-1"></b>{{ text }}</p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn depressed tile @click="dialog = false"> Close </v-btn>
      </template>
    </Dialog>

    <CreateOrUpdatePayment
      v-model="addFormDialog"
      :payment-id="selectedPaymentId"
      :initial-data="currentPaymentDataForForm"
      form-type="utility"
      @save-success="handleSaveSuccess"
      @closed="handleFormDialogClose"
    />

    <DeleteTemplate type="payment" :delete-dialog="deleteDialog" :delete-endpoint="deleteEndpoint"
      v-on:close="deleteDialog = false" v-on:delete:success="getPaymentTypes()">
    </DeleteTemplate>
    <SearchTemplate :dialog="allCollectedDialog" v-on:close="allCollectedDialog = false"></SearchTemplate>

  </v-sheet>
</template>
<script>
import Dialog from "@/view/components/Dialog";
import SearchCriteria from "@/view/components/SearchCriteria";
import { GET_PAYMENT_LIST } from "@/core/lib/payment.lib";
 
import { SET_ERROR } from "@/core/services/store/common.module";
import DeleteTemplate from "@/view/components/DeleteTemplate"; 
import CreateOrUpdatePayment from "./Create-Or-Update-Payment.vue";

 import SearchTemplate from "@/view/components/SearchAllVouchers";
import DateRangePicker from "@/view/components/DateRangePicker";
import Draggable from "vuedraggable";
import { PATCH } from "@/core/services/store/request.module";
import { filter, map } from "lodash";

import {
  SET_SEARCH_TITLE,
  SET_SEARCH_MODEL,
  SET_SEARCH_BAR,
  BEFORE_DESTROY,
} from "@/core/services/store/listing.module";
import { mapGetters } from "vuex"; 
import AutoCompleteInput from "@/view/components/AutoCompleteInput";
import moment from "moment-timezone";
import { SearchEventBus } from "@/core/lib/search.lib";

import { POST } from "@/core/services/store/request.module";
import { formatMoney } from "accounting-js";

export default {
  name: "utility-listing",
  title: "Listing Utility",
  props: {
    status: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selectstatus: null,
      images: null,
      defaultColDefs: [],
      customThead: [],
      searchEnabled: null,
      searchParam: null,
      list: [],
      range: null,
      search_month: null,
      search_year: null,
      months: [
        {
          name: "January",
          value: 1,
        },
        {
          name: "February",
          value: 2,
        },
        {
          name: "March",
          value: 3,
        },
        {
          name: "April",
          value: 4,
        },
        {
          name: "May",
          value: 5,
        },
        {
          name: "June",
          value: 6,
        },
        {
          name: "July",
          value: 7,
        },
        {
          name: "August",
          value: 8,
        },
        {
          name: "September",
          value: 9,
        },
        {
          name: "October",
          value: 10,
        },
        {
          name: "November",
          value: 11,
        },
        {
          name: "December",
          value: 12,
        },
      ],
      text: "Also called a company description, your business description summarizes what your company does, its purpose, and what makes it unique. It's a critical component of your business plan and immediately follows your executive summary",

      sequence: null,
       dialog: false,
       addFormDialog: false,
      dataLoading: false,
      dragStartIndex: null,
      dragOverIndex: null,
      templateList: [{ text: "First", value: "first" }],
      template: "first",
     
      filterType: "all",
      filterDateRange: null,
      speedDial: [],
      whatsappPromotional: false,
      promotions: [],
      currentPage: 1,
      utility: 0,
      pageLimit: 1,
      showingFrom: 0,
      showingTo: 0,
      totalRows: 0,
      pageLoading: true,
      yearlist: [],
      deleteText: null,
      deleteEndpoint: null,
      deleteDialog: false,
      orderDialog: false,
      rOrderId: 0,
      rOrderCode: null,
      rLoading: false,
      rVouchers: [],
      redeemDialog: false,
      cOrderId: 0,
      cOrderCode: null,
      cLoading: false,
      cVouchers: [],
      collectDialog: false,
      allCollectedDialog: false,

      selectedPaymentId: null,
      currentPaymentDataForForm: null,
     
    };
  },
  watch: {
    currentPage() {
      this.getPaymentTypes();
    },
    listingSearch() {
      this.getPaymentTypes();
    },
    filterDateRange() {
      if (this.filterDateRange && this.filterDateRange.length > 1) {
        this.filterType = "all";
        this.getPaymentTypes();
      }
    },
  },
  methods: {
    getRowtype(type) {
    switch (type) {
        case 1:
            return 'Rent';
        case 2:
            return 'Utility';
        default:
            return 'Unknown';
    }
  },
  formatMoney(money) {
      return formatMoney(money, {
        symbol: "RM",
        decimal: ".",
        thousand: ",",
        precision: 2,
        format: "%s%v",
      });
    },
    updatePayment(row) {
      this.selectedPaymentId = row.id;
      this.currentPaymentDataForForm = {
         type: row.type ? row.type.toString() : '2',
         remark: row.remark,
         date: row.date,
         amount: row.amount,
      };
      this.addFormDialog = true;
    },

    addPayment() {
      this.selectedPaymentId = null;
      this.currentPaymentDataForForm = { 
        type: '2',
        remark: null,
        date: null,
        amount: null,
      };
      this.addFormDialog = true;
    },
    stripHtmlTags(content) {
      if (!content) return '';
      const tempElement = document.createElement('div');
      tempElement.innerHTML = content;
      return tempElement.textContent || tempElement.innerText || '';
    },
    formateTime(param) {
      return moment(param).format("hh:mm A");
    },
    updateVisible() {
      const _this = this;

      for (let index = 0; index < _this.defaultColDefs.length; index++) {
        const element = _this.defaultColDefs[index];
        _this.defaultColDefs[index].visible = 0;
        if (_this.defaultColShow.includes(element.field)) {
          _this.defaultColDefs[index].visible = 1;
        }
      }

      _this.$nextTick(() => {
        _this.$store
          .dispatch(POST, {
            url: "group",
            data: { tables: this.defaultColDefs },
          })
          .then((data) => {
            this.customThead = data;
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.getPaymentTypes();
          });
      });
    },
    activeInactive(data, id) {
      const _this = this;
      _this.$store
        .dispatch(PATCH, {
          url: `single-promotion`,
          data: {
            id: id,
            status: Number(data),
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getPaymentTypes();
        });
    },
    reset() {
      this.search_month = null;
      this.search_year = null;
      this.range = null;
      this.getPaymentTypes();
    },

    updateItemOrder(e) {
      this.gfgdg = e;
    },
  
    gochange() {
      this.sequence = 0;
    },
    Sequence() {
      this.sequence = 1;
    },
    updateAddressPerson(param) {
      this.selectstatus = param;
      this.sequence = 0;
      this.getPaymentTypes();
    },
    remarkPop(reason, image) {
      this.text = reason;
      this.images = image;

      this.dialog = true;
    },
    formatedate(param) {
      return moment(param).format("DD/MM/YYYY");
    },
    getColValue(val) {
      if (val.includes(" ")) {
        return val.split(" ").join("_").toLowerCase();
      } else {
        return val.toLowerCase();
      }
    },
    dragstart(index) {
      this.dragStartIndex = index;
    },
    dragover(index) {
      this.dragOverIndex = index;
    },
    dragEnd() {
      const dragStartElement = this.defaultColDefs[this.dragStartIndex];
      this.defaultColDefs.splice(this.dragStartIndex, 1);
      this.defaultColDefs.splice(this.dragOverIndex, 0, dragStartElement);
      this.$nextTick(() => {
        this.$store
          .dispatch(POST, {
            url: "group",
            data: { tables: this.defaultColDefs },
          })
          .then((data) => {
            this.customThead = data;
          })
          .catch((error) => {
            this.logError(error);
          })
          .finally(() => {
            this.getItems();
          });
      });
    },
    drastart(index) {
      this.dragging_element_index = index;
    },
   
    filterTypeChange() {
      this.filterDateRange = null;
    },
    
    routeToUpdate(id) {
      this.$router.push({
        name: "payment-update",
        params: { id },
        query: { t: new Date().getTime() },
      });
    },
    routeToDetail(row) {
      this.$router.push({
        name: "payment-detail",
        params: { month: row.month, year: row.year },
        query: { t: new Date().getTime(), month: row.month, year: row.year },
      });
    },
    deleteConfirm({ code, id }) {
      console.log({ code, id });
      
      this.deleteText = code;
      this.deleteEndpoint = `payment-types/${id}`;
      this.deleteDialog = true;
    },
    searchPromotions() {
      this.getPaymentTypes();
    },
    async getPaymentTypes(search = null) {
      try {
        let form = {
          tab: "utility",
          current_page: this.currentPage,
          search: search,
          selectstatus: this.selectstatus,
          filter_type: this.filterType,
          search_month: this.search_month,
          search_year: this.search_year,
        };
        if (this.range) {
          const dateRange = {
            start_date: this.range[0],
            end_date: this.range[1],
          };
          form = { ...form, ...dateRange };
        }
        this.pageLoading = true;
        const { data, totalPages, showingFrom, showingTo, totalRows, active,Inactive,total,    totalPayments, 
          totalRentPaidThisMonth,
          totalUtilities,
          allyear,
          totalRentPaidLastMonth, 
          totalRefundThisMonth,
          totalRefundLastMonth,
       totalUtilitiesThisMonth,

          totalUtilitiesLastMonth, theads } =
          await GET_PAYMENT_LIST(form);
        this.promotions = data;
        this.pageLimit = totalPages;
        this.showingFrom = showingFrom;
        this.showingTo = showingTo;
        this.totalRows = totalRows;
        this.totalPayments = totalPayments;
         this.totalRentPaidThisMonth = totalRentPaidThisMonth;
        this.totalRentPaidLastMonth = totalRentPaidLastMonth;
        this.totalRefundLastMonth = totalRefundLastMonth;
        this.totalRefundThisMonth = totalRefundThisMonth;
        this.totalUtilities = totalUtilities;
        this.totalUtilitiesThisMonth = totalUtilitiesThisMonth;
        this.totalUtilitiesLastMonth = totalUtilitiesLastMonth;

        this.yearlist = allyear;
        this.total = total;
        this.active = active; 
        this.Inactive = Inactive;
        let thead = theads;
        this.defaultColDefs = thead;
        this.customThead = [];
        for (let index = 0; index < thead.length; index++) {
          let element = thead[index];
          if (element.visible == 1 && element.field != "paid_by") {
            this.customThead.push(element);
          }
        }

        let t_out = filter(thead, (row) => Number(row.visible) == 1);
        this.defaultColShow = map(t_out, "field"); 

        this.$emit("saveAddress", totalRows);
        this.$emit("totalPayments",totalPayments);
        this.$emit("totalRentPaidThisMonth",totalRentPaidThisMonth);
        this.$emit("totalRentPaidLastMonth",totalRentPaidLastMonth);
        this.$emit("totalRefundThisMonth",totalRefundThisMonth);
        this.$emit("totalRefundLastMonth",totalRefundLastMonth);
        this.$emit("totalUtilities",totalUtilities);
        this.$emit("totalUtilitiesThisMonth",totalUtilitiesThisMonth);

        this.$emit("totalUtilitiesLastMonth",totalUtilitiesLastMonth);

      } catch (error) {
        this.$store.commit(SET_ERROR, [{ model: true, message: error }]);
      } finally {
        this.pageLoading = false;
      }
    },
    resetSearch() {
      this.$router
        .replace({
          query: {
            t: new Date().getTime(),
          },
        })
        .then(() => {
          this.$store.dispatch(SET_SEARCH_MODEL, null);
        });
    },
    handleSaveSuccess() {
      this.getPaymentTypes();
    },
    handleFormDialogClose() {
      this.addFormDialog = false;
      this.selectedPaymentId = null;
      this.currentPaymentDataForForm = null;
    },
  },
  async mounted() {
    SearchEventBus.$on("start-search", (argument) => {
      this.searchEnabled = false;
      this.searchParam = argument;
      if (this.searchParam) {
        this.searchEnabled = true;
      }
      this.getPaymentTypes(argument);
    });
    SearchEventBus.$emit("search-template", true);
    this.getPaymentTypes();
    this.$store.dispatch(SET_SEARCH_BAR, true);
    this.$store.dispatch(SET_SEARCH_TITLE, "Utility"); 
  },
  beforeDestroy() {
    this.$store.dispatch(BEFORE_DESTROY);
  },
  components: {
    DeleteTemplate,
    SearchTemplate,
    SearchCriteria,
    Dialog,
    DateRangePicker, 
     Draggable,
    AutoCompleteInput,
    CreateOrUpdatePayment,
  },
  computed: {
    ...mapGetters(["listingSearch"]),
  },
};
</script>

<style>
.table_height .v-data-table__wrapper {
  height: calc(100vh - 360px);
}

.promotion-listing-tr:nth-child(even):hover {
  box-shadow: 0px 0px 10px #666666 !important;
  -webkit-box-shadow: 0px 0px 10px #666666 !important;
  -moz-box-shadow: 0px 0px 10px #666666 !important;
  background-color: #e3f2fd !important;
  position: relative;
  z-index: 5;
}

.promotion-listing-tr:nth-child(odd):hover {
  box-shadow: 0px 0px 10px #666666 !important;
  -webkit-box-shadow: 0px 0px 10px #666666 !important;
  -moz-box-shadow: 0px 0px 10px #666666 !important;
}
.custom_field_height v-input__control {
  max-height: 34px;
  height: 34px;
}
.custom_field_height .v-select__selection {
  max-width: 84%;
}
</style>
